import client from '../apiClient';

const getTenantUsers = (clientId, page = 0, size = 10, search = '', role = '', status = '') =>
    client.get(`/client-admin/users?page=${page}&size=${size}&search=${search}&role=${role}&status=${status}`);

const getTenantUserById = (userId) =>
    client.get(`/client-admin/users/${userId}`);

const createTenantUser = (data) =>
    client.post(`/client-admin/users`, data);

const updateTenantUser = (userId, data) =>
    client.put(`/client-admin/users/${userId}`, data);

const deleteTenantUser = (userId) =>
    client.delete(`/client-admin/users/${userId}`);

const getTenantRoles = () =>
    client.get(`/client-admin/roles`);

const getMe = () =>
    client.get('/client-admin/me');

const updateMe = (data) =>
    client.put('/client-admin/me', data);

const toggleTenantUser = (userId, isActive) =>
    client.patch(`/client-admin/users/${userId}/toggle`, { isActive });

const getLearnerAssessmentPerformance = (userId, page = 0, size = 10) =>
    client.get(`/client-admin/users/${userId}/assessment-performance?page=${page}&size=${size}`);

const getLearnerCoursePerformance = (userId, page = 0, size = 10) =>
    client.get(`/client-admin/users/${userId}/course-performance?page=${page}&size=${size}`);

const getLearnerContentAccess = (userId, page = 0, size = 10) =>
    client.get(`/client-admin/users/${userId}/content-access?page=${page}&size=${size}`);

const getScheduleDetails = (filter,search, page = 0, size = 10) =>
    client.get(`/client-admin/scheduleDetails?filter=${filter}&search=${search}&page=${page}&size=${size}`);

export default {
  getTenantUsers,
  getTenantUserById,
  createTenantUser,
  updateTenantUser,
  deleteTenantUser,
  getTenantRoles,
  getMe,
  updateMe,
  toggleTenantUser,
  getLearnerContentAccess,
  getLearnerCoursePerformance,
  getLearnerAssessmentPerformance,
  getScheduleDetails
};
